/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { AlertCenterStockItemData } from './AlertCenterStockItemData';
import {
    AlertCenterStockItemDataFromJSON,
    AlertCenterStockItemDataFromJSONTyped,
    AlertCenterStockItemDataToJSON,
    AlertCenterStockItemDataToJSONTyped,
} from './AlertCenterStockItemData';

/**
 * 
 * @export
 * @interface ResponseAlertCenterStockItem
 */
export interface ResponseAlertCenterStockItem {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseAlertCenterStockItem
     */
    result: ResponseResult;
    /**
     * 
     * @type {AlertCenterStockItemData}
     * @memberof ResponseAlertCenterStockItem
     */
    data: AlertCenterStockItemData;
}

/**
 * Check if a given object implements the ResponseAlertCenterStockItem interface.
 */
export function instanceOfResponseAlertCenterStockItem(value: object): value is ResponseAlertCenterStockItem {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseAlertCenterStockItemFromJSON(json: any): ResponseAlertCenterStockItem {
    return ResponseAlertCenterStockItemFromJSONTyped(json, false);
}

export function ResponseAlertCenterStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAlertCenterStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': AlertCenterStockItemDataFromJSON(json['data']),
    };
}

export function ResponseAlertCenterStockItemToJSON(json: any): ResponseAlertCenterStockItem {
    return ResponseAlertCenterStockItemToJSONTyped(json, false);
}

export function ResponseAlertCenterStockItemToJSONTyped(value?: ResponseAlertCenterStockItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': AlertCenterStockItemDataToJSON(value['data']),
    };
}

